import { Button } from "react-admin";
import { Link } from "@mui/material";
import { getEnvStyling } from "../utils/tools";

export const LinkButton = ({ to, href, component: _component, ...props }) => {
  const root = getEnvStyling().root;

  href = to || href;
  if (!(href.startsWith("http") || href.startsWith(root))) {
    href = root + href;
  }

  return <Button {...props} component={Link} href={href} />;
};
